import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { SimpleModal } from '@festina-life/ui/structure'
import cx from 'classnames'

const email = 'portal.configuration@festinafinance.com'
const mailtoLink = `mailto:${email}?subject=Feedback%20for%20Development%20Team`

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const SubmitFeedbackModal = ({ isOpen, onClose }: Props) => {
  const translate = useTranslate()

  return (
    <SimpleModal
      isOpen={isOpen}
      title="Submit Feedback"
      closeConfiguration={{ onClose }}
    >
      <div className="flex flex-col gap-y-2">
        <div className="flex flex-col gap-y-1">
          <p className="flex gap-x-1">
            {translate('feedbackModalButton.modal.body.first')}
            <a href={mailtoLink}>{email}</a>.
          </p>
          <p>{translate('feedbackModalButton.modal.body.second')}</p>
          <p>{translate('feedbackModalButton.modal.body.third')}</p>
        </div>
        <div className="flex flex-col gap-y-2">
          <h3>{translate('feedbackModalButton.modal.body.emailTitle')}</h3>
          <pre className={cx('rounded-md p-1', paperStyles({ isFaded: true }))}>
            {translate('feedbackModalButton.modal.body.email', { email })}
          </pre>
        </div>
      </div>
    </SimpleModal>
  )
}
